document.getElementById('prefillTestData')?.addEventListener('click', function() {
    // Test data for prefilling the form
    const testData = {
        customerTitle: 'Dr.',
        firstName: 'Jens',
        lastName: 'de Rond',
        gender: 'Male',
        institution: 'University of Testing',
        department: 'Department of Immunology',
        positionHeld: 'Senior Researcher',
        email: 'derond@redkiwi.nl',
        address: '123 Science Avenue',
        postalCode: '12345',
        city: 'Research City',
        country: 'United Kingdom',
        'country-code-hidden': 'GB',
        'country-name-hidden': 'United Kingdom',
        'password': '@Welkom1',
        'confirmPassword': '@Welkom1',
        membershipNumberOne: '1',
        membershipNumberTwo: '1234',
        permissionEmail: true,
        permissionAddress: true
    };

    // Fill text inputs and selects
    Object.keys(testData).forEach(function(key) {
        const element = document.getElementById(key);
        if (element) {
            if (element.type === 'checkbox') {
                element.checked = testData[key];
            } else {
                element.value = testData[key];
            }
        }
    });

    // Show visual feedback
    const button = this;
    const originalText = button.textContent;
    button.textContent = 'Test Data Loaded!';
    button.style.backgroundColor = '#22c55e';

    setTimeout(function() {
        button.textContent = originalText;
        button.style.backgroundColor = '';
    }, 2000);
});
